import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import ChatComponent from './ChatComponent';
import Tools from './Tools';
import '../components/css/Chat.css';
import { UserChatIcon, ChatCallIcon } from './icons/svgIcons';
import { set } from 'lodash';

const Chatroom = (props) => {

    const [chatSessions, setChatSessions] = useState([]);
    const [receivingChatCall, setReceivingChatCall] = useState(false);
    const [currentTabSession, setCurrentTabSession] = useState(null);
    const [incomingChatSessionId, setIncomingChatSessionId] = useState(null);
    const [minimizedWindow, setMinimizedWindow] = useState(false);
    const [chatMessage, setChatMessage] = useState(false);
    const location = useLocation();
    
    const chatBeep = require("./ui/chatBeep.mp3"); 
    const [audioBeep, setAudioBeep] = useState(new Audio(chatBeep));

    const chatNotifySound = require("./ui/notify.mp3"); 
    const [notifySound, setNotifySound] = useState(new Audio(chatNotifySound));

    const alertInactivitySound = require("./ui/alert.mp3");
    const [alertSound, setAlertSound] = useState(new Audio(alertInactivitySound));

    const updateChatroomSidebar=()=>{
        let currentChatSessions=[...chatSessions];
        currentChatSessions.push({ chatSessionId: incomingChatSessionId });
        setChatSessions(currentChatSessions);

        sessionStorage.setItem('chatSessions', JSON.stringify(currentChatSessions));

        //preselect current new call
        setCurrentTabSession(currentChatSessions.length - 1);

        //reset values
        setReceivingChatCall(false);
        setIncomingChatSessionId(null);
    }


    const connectToConversation = () => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/connectToConversation`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: { sessionId: incomingChatSessionId }
        };
        axios(options).then(response => {
            props.setUserStatusFn({ paused: false, code: 'CHAT_ATTENDING', desc: 'Atendiento chat' });
            updateChatroomSidebar();
            audioBeep.pause();
        })
        .catch((error) => {
            console.log("Error:", error.message);
            //setError(error.message);
        });
    }

    const removeChatSession = (sessionId)=>{
        //let previousChatSessions = chatSessions;
        //let previousChatSessions = [...chatSessions];

        let previousChatSessions =null;
        let chatSessionsSE=sessionStorage.getItem('chatSessions');
        if (chatSessionsSE){
            previousChatSessions = JSON.parse(chatSessionsSE);
        } else {
            previousChatSessions=[];
        }
         
        
        console.log(`🐞DEBUG eliminando sessionId: ${sessionId}, previousChatSessions:${previousChatSessions.length}`);

        let indexChatSession = previousChatSessions.findIndex((cs) => cs.chatSessionId === sessionId);

        //console.log('🐞DEBUG indexChatSession:', indexChatSession);

        if (indexChatSession!==-1){
            previousChatSessions.splice(indexChatSession, 1);
            setChatSessions(previousChatSessions);
            sessionStorage.setItem('chatSessions', JSON.stringify(previousChatSessions));
        }

        //reset current TAB indicator 
        setCurrentTabSession(null);

        //when remove all sessions, change user state
        if (previousChatSessions.length===0){
            //props.setUserStatusFn({ paused: false, code: 'ACTIVE', desc: 'Disponible' });

            //SOLO SI ESTÁ "ATENDIENDO CHAT" LO CAMBIA A "ACTIVO" CUANDO
            //SE ACABAN TODAS LAS CONVERSACIONES
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/userStatus`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {}
            };
            axios(options).then(response => {
                if (response.data.eventCode ==='CHAT_ATTENDING'){
                    props.setUserStatusFn({ paused: false, code: 'ACTIVE', desc: 'Disponible' });
                }
            });

        }
    }


    const cleanInactivityMark = (sessionId) => {
        let currentChatSessions = [...chatSessions];
        let sessionMessage = currentChatSessions.findIndex((session) => session.chatSessionId === sessionId);

        if (sessionMessage !== -1){
            currentChatSessions[sessionMessage].outOfTime=false;
            setChatSessions(currentChatSessions);
        } 
    }

    useEffect(() => {
        const socket = Tools.currentSocketConnection;

        socket.on("chatCall", data => {
            setReceivingChatCall(true);
            setIncomingChatSessionId(data.sessionId);

            //let audioBeep = new Audio(chatBeep);
            audioBeep.play();
        });

        socket.on("chatAnswerFromUser", data => {
            notifySound.play();
            setChatMessage(data)
        });

        socket.on("disconnect", (reason, details) => {
            if (reason ==='transport close'){
                alert('Al parecer has perdido la conexión con el servidor. Para reconectar y actualizar la información más reciente, te recomendamos que refresques la pantalla. Por favor, haz clic en el botón de actualización del navegador (generalmente un círculo con una flecha en la esquina superior) o presiona la tecla F5 en tu teclado.');
            }
        });


        //load previous chat sessions from sessionStorage (if refresh page)
        let previousChatSessions = sessionStorage.getItem('chatSessions');
        if (previousChatSessions){
            setChatSessions(JSON.parse(previousChatSessions));
        } else {
            setChatSessions([]);
        }

    }, []);

    useEffect(() => {
        const interval = setInterval(() => checkLastInteraction(), 60000);
        return () => clearInterval(interval); // Cleanup on component unmount
    }, [chatSessions]);

    useEffect(() => { 
        if (chatMessage){
            let currentChatSessions = [...chatSessions];
            let sessionMessage = currentChatSessions.findIndex((session) => session.chatSessionId === chatMessage.sessionId);

            if (sessionMessage !== currentTabSession){
                if(!currentChatSessions[sessionMessage].unreadMessagesCount){
                    currentChatSessions[sessionMessage].unreadMessagesCount=1;
                } else {
                    currentChatSessions[sessionMessage].unreadMessagesCount = currentChatSessions[sessionMessage].unreadMessagesCount + 1;
                }
                setChatSessions(currentChatSessions);
            } 
        }
    }, [chatMessage]);


    const checkLastInteraction = () => {
        let activeSessionsList = chatSessions.map(c => c.chatSessionId);
        if(activeSessionsList.length>0){

            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/lastInteractionExecutive`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                params: { sessionsList: activeSessionsList }
            };
            axios(options).then(response => {
                let currentChatSessions = [...chatSessions];
                let interactionsOutOfTime = response.data.interactions; 

                let inactiveSessions = false;
                for (let i = 0; i < currentChatSessions.length; i++) {
                    let sessionId = currentChatSessions[i].chatSessionId;
                    let indexSession = interactionsOutOfTime.findIndex((session) => session.sessionId === sessionId);
                    if (indexSession !== -1){
                        currentChatSessions[i].outOfTime=true;
                        inactiveSessions = true;
                    } else {
                        currentChatSessions[i].outOfTime=false;
                    }
                }

                if (inactiveSessions){
                    try {
                        alertSound.play().catch(error => {
                            if (error.name === 'NotAllowedError' || error.name === 'NotSupportedError') {
                                console.log('Audio playback failed. User interaction is required to play audio.');
                            } else {
                                console.error('Error playing notification sound:', error);
                            }
                        });
                    } catch (error) {
                        console.error('Unexpected error while trying to play notification sound:', error);
                    }
                }

                setChatSessions(currentChatSessions);
            }).catch((error) => {
                console.log("Error:", error.message);
            });
        }
    }

    return (
        <div className={minimizedWindow ? 'chatroom minimized' :'chatroom'}>
            <div className={chatSessions.length > 0 ? 'chatroomSidebar' :'chatroomSidebar empty'}>
                <div className="wrapper">
                    {chatSessions.map((chatSession, index) => (
                        <div key={index} className={`${currentTabSession === index ? 'user selected' : 'user'} ${chatSession.outOfTime ? 'blink' : ''}`}>
                            <a onClick={() => {setCurrentTabSession(index); chatSession.unreadMessagesCount=null;}}>
                                <UserChatIcon width="35" height="35" />
                                <div className="wrapper">
                                    <span className="flex flexSpaceBetween flexAICenter">
                                        <span>Usuario {index + 1}</span>
                                        {chatSession.unreadMessagesCount?(<span className="bubble">{chatSession.unreadMessagesCount}</span>):null}
                                    </span>
                                    <span className='extraInfo'>Sesion ID {chatSession.chatSessionId}</span>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
                {receivingChatCall ? (
                    <div><button className="chatCall flexIcon" onClick={() => connectToConversation()}><ChatCallIcon width="22" height="22" />Contestar</button></div>
                ) : null}

            </div>

            <div className="chatroomContent">
                <button className='minimize' onClick={() => setMinimizedWindow(!minimizedWindow)}>-</button>
                {chatSessions.map((chatSession, index) => (
                        currentTabSession === index ? (
                        <ChatComponent key={index} removeChatSessionFn={removeChatSession} sessionId={chatSession.chatSessionId} cleanInactivityMark={cleanInactivityMark} /> 
                        ):null
                    )
                )}

                {chatSessions.length===0?(
                    <div className="emptyState">
                        Esperando comunicación con usuarios, las conversaciones activas aparecerán en la barra a la izquierda de la pantalla (desde ahí también aparecerán las nuevas llamadas entrantes)
                    </div>
                ):null}


            </div>
        </div>
    );

}

export default Chatroom;
